module.exports = __webpack_public_path__ + "static/media/gvzx.6dfb00d8.png";